export default {
  flock_app_store: 'Tienda de aplicaciones de Flock',
  get_more_apps: 'Obtenga m\u00e1s aplicaciones',
  app_store_button_label: 'Aplicaciones',
  directory_button_label: 'Directorio',
  roster_title: 'Canales y contactos',
};



// WEBPACK FOOTER //
// ./src/I18N/es-MX.js